// extracted by mini-css-extract-plugin
export default {"nav-logo":"Header_nav-logo__k9sBo","nav-bar":"Header_nav-bar__aWfLn","nav-link-desktop":"Header_nav-link-desktop__4LkU9","nav-link-mobile":"Header_nav-link-mobile__ZEc1u"};